import { AppSettings } from '@/types/appSettings'

export const createDefaultAppSettings = (): AppSettings => ({
  tabs: [
    { name: 'basicInfo', order: 1, isActive: true },
    { name: 'laboTest', order: 2, isActive: true },
    { name: 'vitalSign', order: 3, isActive: true },
    { name: 'ecg', order: 4, isActive: true },
    { name: 'dicom', order: 5, isActive: true },
    { name: 'image', order: 6, isActive: true },
    { name: 'document', order: 7, isActive: true },
    { name: 'dispensation', order: 8, isActive: true },
    // { name: 'prescription', order: 9, isActive: true },
    { name: 'medicationInstruction', order: 9, isActive: true },
    { name: 'bloodSugarLevel', order: 10, isActive: true },
    { name: 'hd', order: 11, isActive: true },
    { name: 'pd', order: 12, isActive: true }
  ]
})
